module.exports = __webpack_public_path__ + "media/alph.31975132.wav";